// @ts-nocheck
import * as React from "react";

const EmailFill: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M19 4H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3Zm0 2-6.5 4.47a1 1 0 0 1-1 0L5 6h14Z"
            />
        </svg>
    );
};

export default React.memo(EmailFill);
